import { Link } from "react-router-dom";

const LINKS = {
  Services: [
    { label: "Invoice OCR API", href: "https://ocr.tyosolution.com" },
    { label: "ScoreMyCV", href: "https://scoremycv.tyosolution.com" },
    { label: "PDF Splitter", href: "https://pdf-splitter.tyosolution.com" },
    { label: "Image Optimizer API", href: "https://img.tyosolution.com" },
    { label: "News & Update Tracking", href: null, action: "services" },
  ],
  Company: [
    { label: "Features", href: null, action: "features" },
    { label: "How It Works", href: null, action: "how-it-works" },
    { label: "Pricing", href: null, action: "pricing" },
    { label: "Contact", href: null, action: "contact" },
  ],
};

export default function Footer() {
  const scrollTo = (id) => {
    document.querySelector(`#${id}`)?.scrollIntoView({ behavior: "smooth" });
    window.history.replaceState(null, "", `#${id}`);
  };

  return (
    <footer className="bg-[#060c1e] border-t border-white/[0.06] pt-16 pb-8 px-6 md:px-10" data-testid="footer">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-14">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-[#38BDF8] flex items-center justify-center shadow-[0_0_16px_rgba(56,189,248,0.35)]">
                <span className="text-[#080f23] font-black text-sm">T</span>
              </div>
              <span className="font-semibold text-white text-[1.05rem]">
                Tyo <span className="text-[#38BDF8]">Solution</span>
              </span>
            </div>
            <p className="text-[#64748B] text-sm leading-relaxed mb-6 max-w-xs">
              Digital automation for modern businesses — OCR, CV scoring, PDF tools, and intelligence solutions.
            </p>
            <div className="flex flex-col gap-2">
              <a
                href="https://ocr.tyosolution.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-xs font-mono text-[#38BDF8] hover:text-white transition-colors"
              >
                ocr.tyosolution.com →
              </a>
              <a
                href="https://scoremycv.tyosolution.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-xs font-mono text-[#38BDF8] hover:text-white transition-colors"
              >
                scoremycv.tyosolution.com →
              </a>
              <a
                href="https://pdf-splitter.tyosolution.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-xs font-mono text-[#38BDF8] hover:text-white transition-colors"
              >
                pdf-splitter.tyosolution.com →
              </a>
              <a
                href="https://img.tyosolution.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-xs font-mono text-[#38BDF8] hover:text-white transition-colors"
              >
                img.tyosolution.com →
              </a>
            </div>
          </div>

          {Object.entries(LINKS).map(([category, items]) => (
            <div key={category}>
              <h4 className="text-xs font-semibold uppercase tracking-widest text-[#64748B] mb-4">{category}</h4>
              <ul className="space-y-3">
                {items.map(item => (
                  <li key={item.label}>
                    {item.href ? (
                      <a
                        href={item.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sm text-[#94A3B8] hover:text-white transition-colors"
                      >
                        {item.label}
                      </a>
                    ) : (
                      <button
                        onClick={() => scrollTo(item.action)}
                        className="text-sm text-[#94A3B8] hover:text-white transition-colors text-left"
                      >
                        {item.label}
                      </button>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-white/[0.06] pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-[#64748B]">
            © {new Date().getFullYear()} Tyo Solution. All rights reserved.
          </p>
          <div className="flex items-center gap-5 flex-wrap justify-center">
            <Link to="/terms" className="text-xs text-[#64748B] hover:text-white transition-colors">Terms of Service</Link>
            <Link to="/privacy" className="text-xs text-[#64748B] hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/refund" className="text-xs text-[#64748B] hover:text-white transition-colors">Refund Policy</Link>
            <a
              href="https://ocr.tyosolution.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-[#64748B] hover:text-white transition-colors"
            >
              Try Invoice OCR API →
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
